import { writable } from "svelte/store";

const registrationList = () => {
	let store = writable(window.registrationList);

	return {
		...store
	};
};

export default registrationList();
